import useSWRImmutable from 'swr/immutable';
import capsFetcher from '../../shared/capsFetcher';
import usePrequal from '../../prequal/usePrequal';

const fetcher = async (key) => {
  const res = await capsFetcher({
    url: key,
  });
  return res.data;
};

const useApplication = (options) => {
  const { data: prequal } = usePrequal();
  return useSWRImmutable(
    `/applications/${prequal.applicationId}`,
    fetcher,
    { suspense: true, ...options },
  );
};

export default useApplication;
